import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneAndroid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#airplane-android_svg__a)">
      <path d="M7 11a1 1 0 0 1-.89-.55l-2-4a1 1 0 0 1 1.78-.9l2 4a1 1 0 0 1-.44 1.34A.93.93 0 0 1 7 11M17 11a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 17 11" />
      <path d="M21 19H3a1 1 0 0 1-1-1 10 10 0 0 1 20 0 1 1 0 0 1-1 1M4.06 17h15.88a8 8 0 0 0-15.88 0" />
      <path d="M15 15h-.19a.6.6 0 0 1-.19-.06.9.9 0 0 1-.54-.54A1 1 0 0 1 14 14a1 1 0 0 1 .29-.71l.16-.12a.6.6 0 0 1 .17-.09.6.6 0 0 1 .19-.06.86.86 0 0 1 .39 0l.18.06.18.09.15.12a1 1 0 0 1 .21 1.09 1 1 0 0 1-.21.33l-.15.12-.18.09-.18.08zM9 15h-.19a.6.6 0 0 1-.19-.06.6.6 0 0 1-.17-.09 1 1 0 0 1-.16-.12 1 1 0 0 1-.21-.33A1 1 0 0 1 8 14a1.05 1.05 0 0 1 .29-.71A1 1 0 0 1 9.2 13l.18.06.18.09.15.12A1 1 0 0 1 10 14a1 1 0 0 1-.08.38.9.9 0 0 1-.54.54L9.2 15z" />
    </g>
    <defs>
      <clipPath id="airplane-android_svg__a">
        <path fill="#fff" d="M2 5h20v14H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirplaneAndroid;
